import { createSlice } from '@reduxjs/toolkit'
import { saveState } from '../../localStorage'

export const apiToken = createSlice({
  name: 'token',
  initialState: {
    value: null
  },
  reducers: {
    assignToken: (state, action) => {
      state.value = action.payload
      saveState("token", state);
    }
  }
})

// Action creators are generated for each case reducer function
export const { assignToken } = apiToken.actions

export default apiToken.reducer